export { default } from "./HomeModelCard";
